import React from 'react'
import ModeratorBottomPanel from "./ModeratorBottomPanel";
import agent from "../../agent";
import ModeratorPlayersCard from "./ModeratorPlayersCard";
import './ModeratorPanel.css'
import Popup from "../Popup";
import {INFRA_TYPE, TEAMS_COUNT, TUTORIAL_SET_STATE} from "../../constants/Constants";
import Gameplay from "../Gameplay";
import Loader from "../Loader";
import TradesWindow from "../InGameUI/Windows/TradesWindow";
import GameData from "../../gameplay/model/GameData";
import GameController from "../../gameplay/controllers/GameController";
import ModeratorStatistics from "./ModeratorStatistics";
import ConfirmPopup from "../InGameUI/Popups/ConfirmPopup";
import SaveSelector from "../Selectors/SaveSelector/SaveSelector";

class ModeratorPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      called: [],
      saves: [],
      game_info: null,
      popup: {
        message: "test", isShow: false
      },
      showTeamGameID: null,
      game_state: 0,
      isLoading: false,
      isShowTrades: false,
      isShowStatistics: false,
      isShowStatsButton: false,
      isShowConfirm: false,
      isShowSaves: false,
      isTeamReady: {},
      game_day: 1
    }
    this.readGameHeartbeat = null;
    this.gameDataHeartbeat = null;
    this.lastDataChange = null;
    this.changeState = {};
    this.checkTimeout = null;
  }

  toggleConfirm() {
    this.setState({
      isShowConfirm: !this.state.isShowConfirm
    })
  }

  onOpenGameplay(teamID) {
    window.teamID = teamID;
    this.setState({
      showTeamGameID: teamID
    });
  }

  toggleTrades() {
    this.setState({
      isShowTrades: !this.state.isShowTrades
    })
  }

  getGameState() {
    if (this.state.showTeamGameID)
      return;

    let game = this.state.game_info;
    if (game.is_started) {
      for (let i = 0; i < game.teams.length; i++) {
        let teamId = game.teams[i].uuid;
        agent.GamePlay.gameDataStatus(teamId, changed => {
          if (!this.changeState[teamId] || this.changeState[teamId].last_changed !== changed.last_changed) {
            agent.GamePlay.getGameData(teamId, (response) => {
              GameData.CurrentModeratorGameDatas[teamId] = GameData.CreateGameData(response);
              let readyTeams = this.state.isTeamReady;
              readyTeams[teamId] = response.state < response.teamState;

              this.setState({
                game_day: response ? response.day : this.state.game_day,
                game_state: response ? response.state : this.state.game_state,
                isLoading: false,
                isTeamReady: readyTeams
              });
            });
          }
          this.changeState[teamId] = changed;
        });
      }

      agent.Game.getGameSave(this.props.gameId, res => {
        // Сортируем по году, дню и фазе по убыванию
        let sorted = res.data.sort((a, b) => {
          if (a.year === b.year) {
            if (a.day === b.day) {
              return b.state - a.state;
            } else {
              return b.day - a.day;
            }
          } else {
            return b.year - a.year;
          }
        });

        this.setState({
          saves: sorted || []
        });
      });
    }

  }

  checkGameStatus() {
    agent.Game.gameStatus(this.props.gameId, response => {
      if (this.lastDataChange === null || this.lastDataChange.last_changed !== response.last_changed) {
        this.readGame();
      }
      this.lastDataChange = response;
    })
  }

  endModeratorCall(teamId) {
    agent.Moderator.endCallModerator(this.props.gameId, teamId, (response) => {
      console.log(response);
    });
  }

  componentDidMount() {
    agent.Game.readGame(this.props.gameId, (response) => {
      console.log("read game")
      if (!(response.teams) || response.teams.length === 0) {
        console.log(response)
        response.teams = new Array(TEAMS_COUNT);

        for (let i = 0; i < TEAMS_COUNT; i++) {
          response.teams[i] = {
            users: [], name: `Команда ${i + 1}`
          }
        }
      } else {
        if (!this.readGameHeartbeat) {
          this.readGameHeartbeat = setInterval(this.checkGameStatus.bind(this), 5000)
        }
      }
      this.setState({
        game_info: response
      })
      this.getGameState();
    });
    this.gameDataHeartbeat = setInterval(this.getGameState.bind(this), 5000);
    document.body.classList.add("app-overflow-y");
    window.GameData = GameData;

    this.checkIfCanShow();
  }

  checkIfCanShow() {
    this.checkTimeout = setTimeout(() => {
      if (Object.keys(GameData.CurrentModeratorGameDatas).length) {
        this.setState({
          isShowStatsButton: true
        })
      } else {
        this.checkIfCanShow();
      }
    }, 2000);
  }

  componentWillUnmount() {
    clearInterval(this.readGameHeartbeat);
    clearInterval(this.gameDataHeartbeat);
    clearInterval(this.checkTimeout);
    document.body.classList.remove("app-overflow-y");
  }

  allTeamsReady() {
    let teams = this.state.game_info.teams;
    for (let i = 0; i < teams.length; i++) {
      if (teams[i].state <= TUTORIAL_SET_STATE) {
        return false;
      }
    }
    return true;
  }

  readGame(onFinish) {
    agent.Game.readGame(this.props.gameId, (response) => {
      if (!(response.teams) || response.teams.length === 0) {
        response.teams = new Array(TEAMS_COUNT);

        for (let i = 0; i < TEAMS_COUNT; i++) {
          response.teams[i] = {
            users: [], name: `Команда ${i + 1}`
          }
        }
      }
      console.log(response)
      this.setState({
        game_info: response
      });
      if (onFinish) {
        onFinish()
      }
    });

    this.checkModeratorCalled();
  }

  checkModeratorCalled() {
    agent.Moderator.checkStatus(this.props.gameId, (response) => {
      if (response.teams && response.teams.length) {
        this.teamsThatCalled = response.teams.filter(team => team["is-called-moderator"] === true);
        // console.log(response);
        // console.log(this.teamsThatCalled);

        this.setState({
          called: this.teamsThatCalled || []
        })
      }
    });
  }

  onPlay() {
    let game = this.state.game_info;

    if (this.state.isShowStatistics) {
      this.setState({ isShowStatistics: false });
    }

    let allTeamsHasPlayers = true;
    for (let team of game.teams) {
      if (team.users.length === 0) {
        allTeamsHasPlayers = false;
        break;
      }
    }

    if (game && game.teams && allTeamsHasPlayers) {
      if (!game.is_started) {
        let teams = game.teams;
        let request = {
          teams: [TEAMS_COUNT]
        };
        for (let i = 0; i < teams.length; i++) {
          let users = [teams[i].users.length]
          for (let j = 0; j < teams[i].users.length; j++) {
            console.log(teams[i].users[j].id)
            users[j] = {
              id: teams[i].users[j].id
            }
          }
          request.teams[i] = {
            name: teams[i].name,
            users: users
          }

        }
        console.log(JSON.stringify(request));
        agent.Game.updateGame(this.props.gameId, request, (response) => {
          console.log(response);
          agent.Game.startGame(this.props.gameId, (response) => {
            console.log(response);
            if (!this.readGameHeartbeat) {
              this.readGameHeartbeat = setInterval(this.readGame.bind(this), 2000)
            }
          });
        });
      } else {
        let firstTeamState = game.teams[0].state;

        if (firstTeamState !== 8) {
          alert("Команда не прошла полностью онбординг!");
          return false;
        }

        for (const id in GameData.CurrentModeratorGameDatas) {
          const teamGameData = GameData.CurrentModeratorGameDatas[id];
          const trains = teamGameData.currentTrains;
          const teamName = this.state.game_info.teams.filter(t => t.uuid === id)[0].name;

          for (let shop of teamGameData.repairShops) {
            const teamInfraParts = shop.partsType === INFRA_TYPE ?
              GameController.calculateAvaliablePartsPath(shop, teamGameData)
              : GameController.calculateParts(shop, teamGameData)
            const teamInfraPeople = shop.partsType === INFRA_TYPE ?
              GameController.calculateAvaliableBrigadesChipsPath(shop, teamGameData):
              GameController.calculateRepairBrigadeChips(shop, teamGameData)

            if (teamInfraParts < 0) {
              alert(`Проблема у команды «${teamName}»!<br>Отрицательные запчасти`, false, true);
              return;
            }

            if (teamInfraPeople < 0) {
              alert(`Проблема у команды «${teamName}»!<br>Отрицательные трудозатраты`, false, true);
              return;
            }
          }

          if (this.state.game_state === 5) {
            // Если вообще нет поезда -- пропускаем
            if (!trains || !trains.length) continue;

            let validation = GameController.validateEndEvening(teamGameData, trains);

            if (!validation.status) {
              alert(`Проблема у команды «${teamName}»!<br>${validation.error}`, false, true);
              return;
            }
          }
        }

        this.setState({
          isLoading: true,
        });

        const processResponse = data => {
          if (data.body) {
            if (data.body.error) {
              alert("Произошла ошибка на стороне сервера! Обратитесь к разработчикам");
            }
          }
        }

        switch (this.state.game_state) {
          case 0:
            agent.GamePlay.startYear(game.uuid, processResponse);
            break;
          case 1:
            agent.GamePlay.startMorning(game.uuid, processResponse);
            break;
          case 2:
            agent.GamePlay.startDay(game.uuid, processResponse);
            break;
          case 3:
            agent.GamePlay.startEvening(game.uuid, processResponse);
            break;
          case 4:
            agent.GamePlay.startLateEvening(game.uuid, processResponse);
            break;
          case 5:
            agent.GamePlay.endDay(game.uuid, processResponse);
            break;
          default:
            break;
        }
      }
    } else {
      alert("Не во всех командах есть игроки,<br> начать год нельзя!", false, true);
    }
  }

  toggleStatistics() {
    this.setState({
      isShowStatistics: !this.state.isShowStatistics
    })
  }

  toggleSaves() {
    this.setState({
      isShowSaves: !this.state.isShowSaves
    })
  }

  onUsersAdded(index, users) {
    this.teams[index].users = users;
  }

  handleError(message) {
    this.setState({
      popup: {
        isShow: true, message: message
      }
    })
  }

  handleClosePopup() {
    this.setState({
      popup: {
        isShow: false, message: ""
      }
    });
  }

  render() {
    if (!this.state.game_info) return "";
    let teamsCards = [];
    let game = this.state.game_info;
    let teams = game.teams.sort((a, b) => a.name.localeCompare(b.name));
    for (let i = 0; i < TEAMS_COUNT; i++) {
      if (game && teams && teams.length > i) {
        let thisCardTeam = teams[i];
        teamsCards.push(<ModeratorPlayersCard
          key={i}
          index={i}
          parent={this}
          team={thisCardTeam}
          onError={this.handleError.bind(this)}
          allTeamsReady={this.allTeamsReady()}
          openGameplay={this.onOpenGameplay.bind(this)}
          isTeamReady={this.state.isTeamReady[thisCardTeam.uuid]}
        />);
      } else {
        if (this.state.game_info != null) {
          teamsCards.push(<ModeratorPlayersCard
            key={i}
            index={i}
            onUsersAdded={this.onUsersAdded.bind(this)}
            parent={this}
            onError={this.handleError.bind(this)}
            allTeamsReady={this.allTeamsReady()}
            openGameplay={this.onOpenGameplay.bind(this)}
          />);
        }
      }
    }

    let statistics = this.state.isShowStatistics && <ModeratorStatistics
      onHide={this.toggleStatistics.bind(this)} teams={game.teams}/>;


    let savesWindow = this.state.isShowSaves &&
      <SaveSelector saves={this.state.saves} gameId={this.props.gameId} onHide={this.toggleSaves.bind(this)}/>;

    let confirmPopup = this.state.isShowConfirm &&
      <ConfirmPopup
        message={"<p>Вы уверены, что хотите сменить фазу всем игрокам?</p>"}
        title={"Смена фазы"}
        onOk={() => {
          this.onPlay();
          this.toggleConfirm();
        }} onCancel={this.toggleConfirm.bind(this)}
      />;

    let mainView = <div>
      <div className='moderator-main-widget'>
        {teamsCards}

        {this.state.popup.isShow ? <Popup
          onClose={this.handleClosePopup.bind(this)}>
          {this.state.popup.message}
        </Popup> : ""}
        {this.state.isShowTrades &&
          <TradesWindow teams={this.state.game_info.teams} onHide={this.toggleTrades.bind(this)}/>}
        {statistics}
        {confirmPopup}
        {savesWindow}
      </div>
      <div>
        <ModeratorBottomPanel
          parent={this} canShowStats={this.state.isShowStatsButton}
          onPressPlay={this.toggleConfirm.bind(this)}
          openStats={this.toggleStatistics.bind(this)}
          openSaves={this.toggleSaves.bind(this)}
          game_state={this.state.game_state} openTrades={this.toggleTrades.bind(this)}
          game_day={this.state.game_day}
        />
      </div>
    </div>;

    let gameplayPanel = <div style={{
      "position": "absolute", "top": "60px", "display": "flex"
    }}>
      <Gameplay
        width={window.innerWidth} height={window.innerHeight - 60} teamID={this.state.showTeamGameID}
        openDictionaryAt={this.props.openDictionaryAt}
      />
      <div style={{
        "position": "absolute", "top": "0px", "right": "0px", "width": "50px", "height": "50px"
      }} className="main-btn" onClick={() => {
        this.setState({showTeamGameID: null})
      }}>X
      </div>
    </div>

    return <div>
      {this.state.showTeamGameID != null ? gameplayPanel : mainView}
      <Loader isActive={this.state.isLoading}/>
    </div>
  }
}

export default ModeratorPanel;
